module.exports = __webpack_public_path__ + "img/han.821d64d6.png";